import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import useFetch from '../../hooks/useFetch';

const DisplayRoutine = () => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const [fetchData] = useFetch();
  const [routines, setRoutines] = useState([]);

  useEffect(() => {
    const fetchRoutines = async () => {
      try {
        const config = {
          url: '/routine/getroutine',
          method: 'post',
          data: { userId: authState.user._id },
          headers: { Authorization: authState.token },
        };

        const response = await fetchData(config);
      // console.log('API Response:', response);
        if (response && response.routines) {
          setRoutines(response.routines);
        } else {
          console.error('Unexpected response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching routines:', error);
      }
    };
    fetchRoutines();
  }, [authState, fetchData]);

  const formatDate = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    // const hours = jsDate.getHours().toString().padStart(2, '0');
    // const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    // const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year}`;
};


  return (
    <MainLayout>
      <div className="w-full mt-12 px-4">
        <h2 className="text-xl font-bold text-center mb-6 text-yellow-200">Classroom Routines</h2>
        {routines && routines.length > 0 ? (
          <div className="flex justify-center items-center">
            <div className="flex flex-col justify-center">
              {routines.map((routine, index) => (
                <div className='flex flex-col'>
                  {index === 0 && (
                    <div>
                      <h2 className="text-lg font-semibold text-orange-400">
                        {routine.title} Class: {routine.className}
                      </h2>
                      <h2 className="text-lg font-semibold text-green-400">
                        Class: {routine.className}
                      </h2>
                      <p className="text-sm text-white mb-4">
                        {formatDate(routine.startDate)} to{' '}
                        {formatDate(routine.endDate)}
                      </p>
                    </div>
                  )}
                  <div
                    key={index}
                    className="flex flex-col w-full justify-center bg-gray-600 shadow-md rounded-lg p-6 border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                  >
                    
                    <h3 className="text-lg font-semibold text-white">
                      {routine.day}
                    </h3>
                  
                    <ul className="space-y-2">
                      {routine.subjects.map((subject, idx) => (
                        <li
                          key={idx}
                          className="flex items-center text-sm text-white"
                        >
                          <span className='w-80'>{subject.subjectName}</span>
                          <span className="font-medium ml-12">{subject.time}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center text-orange-600 mt-10">
            <p>No routines found.</p>
          </div>
        )}
        <div className="text-center text-orange-600 mt-10">
            <button
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 transition duration-300"
              onClick={() => navigate('/routine-create')}
            >
              Create Routine
            </button>
          </div>
      </div>
    </MainLayout>
  );
};

export default DisplayRoutine;
